import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=8e715372"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"
import style0 from "./AddNote.vue?vue&type=style&index=0&id=8e715372&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e715372')) {
      api.createRecord('8e715372', component.options)
    } else {
      api.reload('8e715372', component.options)
    }
    module.hot.accept("./AddNote.vue?vue&type=template&id=8e715372", function () {
      api.rerender('8e715372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/dialog/AddNote.vue"
export default component.exports